import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-no-shipment',
    templateUrl: './no-shipment.component.html',
    styleUrls: ['./no-shipment.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatIconModule
    ]
})
export class NoShipmentComponent implements OnInit {
  @Input() message: string;
  @Input() isShipmentListPage: string;
  @Input() icon: string;
  constructor() {}

  ngOnInit() {}
}
